import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import {
  MobileStepperStyled,
  StepLabel,
  CircularProgressStyled,
  BaseCircularProgressStyled,
} from '../../HeaderStyled';
import {
  selectTotalSubNavItems,
  selectCurrentSubNavItem,
} from 'enrollment/components/BottomNavigation/services';
import {
  selectActiveHeader,
  selectHeaderItems,
} from '../EnrollmentNavigation/services';

export const MobileStepper = () => {
  const { t } = useTranslation('common');
  const activeHeader = useSelector(selectActiveHeader);
  const navItems = useSelector(selectHeaderItems);
  const totalSubNavItems = useSelector(selectTotalSubNavItems);
  const currentSubNavItem = useSelector(selectCurrentSubNavItem);

  if (activeHeader === -1) {
    return <MobileStepperStyled />;
  }

  const stepperNum = activeHeader + 1;
  const stepperPercent = (stepperNum / navItems.length) * 100;
  const activeHeaderName = navItems[activeHeader];
  let nextItem = '';
  if (totalSubNavItems && totalSubNavItems[currentSubNavItem] !== undefined) {
    if (activeHeaderName === 'benefits') {
      nextItem = totalSubNavItems[currentSubNavItem] || '';
    } else {
      nextItem = t(
        `navigation.enrollment:${activeHeaderName}.${totalSubNavItems[currentSubNavItem]}`
      );
    }
  } else if (activeHeader + 1 < navItems.length) {
    nextItem = t(`navigation.enrollment:nav.${navItems[activeHeader + 1]}`);
  }

  return (
    <MobileStepperStyled className="row">
      <div data-testid="progress-icon">
        <BaseCircularProgressStyled
          variant="determinate"
          size={48}
          thickness={2}
          value={100}
        />
        <CircularProgressStyled
          variant="determinate"
          size={48}
          thickness={2}
          value={stepperPercent}
          aria-label="loading"
        />
        <StepLabel>{stepperNum}</StepLabel>
      </div>
      <div className="ml-2">
        <p className="bold mb-0 text-capitalize">{activeHeaderName}</p>
        <p className="caption text-capitalize">
          {t('next')}: {nextItem ? nextItem : ''}
        </p>
      </div>
    </MobileStepperStyled>
  );
};
